import React from 'react';

import * as utils from "../../../utils/utils";
import * as costActions from "../../../actions/cost";
import * as documentActions from "../../../actions/documents";

export default class UploadFile extends React.Component {

    onChange(e) {
        if (e.target.files.length > 0) {
            let file = e.target.files[0];
            this.props.schema.dispatch(costActions.uploadFile(this.props.schema.item.id, file));
        }
    }

    render() {
        return (
            <div>
                {utils.notNullNorUndefined(this.props.schema.item) && <div>
                    <label>{this.props.schema.title}</label> <br/>
                    {utils.notNullNorUndefined(this.props.formData) && this.props.formData.indexOf("http") === 0 &&
                    <button onClick={(e) => {
                        this.props.schema.dispatch(documentActions.downloadFile(this.props.formData));
                        e.preventDefault();
                    }} style={{outline: 'none', background: 'none', border: 'none', padding: '10px 0'}}>
                        View file</button>}
                    <input type="file" onChange={this.onChange.bind(this)}/> <br />
                </div>}

                {!utils.notNullNorUndefined(this.props.schema.item) && <div>
                    <label>{this.props.schema.title}</label> <br/>
                    <i>Save to be able to add a file</i>
                </div>}
            </div>
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/forms/fields/UploadFile.js